import fetch from './fetch';
import { IVerifyVoucherCodeReq, TVerifyVoucherApiResponse } from './voucher.types';

export const verifyVoucherCode = (code: string): TVerifyVoucherApiResponse => {
  const payload: IVerifyVoucherCodeReq = { code };
  return fetch('POST', '/vouchers/vip-code', payload);
};
